import React from "react";
import { Avatar, Col, Row, Typography } from "antd";
import { ShopOutlined } from "@ant-design/icons";

export const RegistryDisplayOrganizationName = ({ name }) => {
  return (
    <div>
      <Row align="middle" gutter={[8, 0]}>
        <Col>
          <Avatar
            style={{ backgroundColor: "#87d068" }}
            icon={<ShopOutlined />}
          />
        </Col>
        <Col>
          <Row>
            <Col>
              <Typography.Text style={{ fontSize: 16, fontFamily: 'Lexend' }}>
                {name}
              </Typography.Text>
            </Col>
          </Row>
        </Col>
      </Row>
    </div>
  );
};
